<script setup lang="ts">
import BrandItem from './BrandItem.vue'
import HScrollRow from '~/components/UI/HScrollRow.vue'

const { brandList } = storeToRefs(useBrandStore())
</script>

<template>
  <div
    class="xl:container relative w-full flex flex-col justify-center items-center gap-8 pt-8 pb-16 sm:pb-8 px-0 sm:px-16 bg-white rounded-[30px]">
    <h2 class="text-2xl sm:text-4xl text-center text-primary font-bold">
      I nostri Partner
    </h2>
    <HScrollRow :scroll-by="280">
      <div v-for="brand in brandList" :key="brand.name" class="flex-shrink-0 w-28 sm:w-36 flex justify-center items-center">
        <BrandItem :data="brand" />
      </div>
    </HScrollRow>
  </div>
</template>
